<template>
  <div class="agent-card-wrap">
    <div class="agent-card">
      <div class="agent-dept">
        {{ deptText }}
      </div>
      <div>
        <div class="agent-photo-stock">
          <emp-photo
            :emp-id="agent.emp_id"
            :emp-ics="ics"
            :large-badge="true"
            @click.native="openAgentPage"
          />

          <div class="agent-stock">
            <div class="agent-sale-wrap" v-if="agent.sale > 0" @click="openStockPage('sale')">
              <div class="agent-sale-title">
                {{ $t('stock_info.SALE_UNIT') }}
              </div>
              <div class="agent-sale-unit">
                {{ agent.sale }}
              </div>
            </div>

            <div class="agent-lease-wrap" v-if="agent.lease > 0" @click="openStockPage('lease')">
              <div class="agent-lease-title">
                {{ $t('stock_info.LEASE_UNIT') }}
              </div>
              <div class="agent-lease-unit">
                {{ agent.lease }}
              </div>
            </div>
          </div>
        </div>

        <div class="agent-name-tag">
          <div class="agent-name">
            {{ name }}
          </div>
          <div class="manager-tag" v-if="agent.is_manager === '1'">
            {{ $t('find.MANAGER') }}
          </div>
          <div class="mitaclub-tag" v-if="agent.mitaclubing === '1'">
            {{ $t('find.MITACLUB') }}
          </div>
        </div>

        <div class="agent-title">{{ title }} ({{ agent.licence }})</div>

        <div class="agent-address">
          <i class="fa fa-map-marker-alt" aria-hidden="true"></i> {{ address }}
        </div>
      </div>
      <div class="agent-contact">
        <div class="phone">
          <a :href="phoneUrl" @click="sendReport('Mobile')"
            ><div class="phone-icon"></div>
            {{ agent.phone }}</a
          >
        </div>
        <div class="whatsapp">
          <a :href="whatsappUrl" @click="sendReport('Whatsapp')" target="_blank">
            <img class="icon" src="/ics/property/img/details/whatsapp.svg" /> Whatsapp
          </a>
        </div>
        <div
          class="wechat"
          @click="
            sendReport('WeChat');
            showWechatPopup();
          "
          v-if="agent.wechat_id"
        >
          <div class="wechat-icon"></div>
          WeChat
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CornerTag from '@/components/Stock/CornerTag';
import IcsTag from '@/components/Agent/IcsTag';
import EmpPhoto from '@/components/Stock/EmpPhoto';
import Pill from '@/components/Pill';
import userBehaviour from '@/api/userBehaviour';

export default {
  props: ['agent', 'selectedDistricts'],
  components: {
    CornerTag,
    IcsTag,
    EmpPhoto,
    Pill,
  },
  computed: {
    ics() {
      let empIcs = '';
      if (this.agent) {
        empIcs = this.agent.market_type;
        if (empIcs === 'O') {
          empIcs = 'C';
        }
      }

      return empIcs.toLowerCase();
    },
    name() {
      let n = this.agent ? `${this.agent.chi_name_long} ${this.agent.nickname}` : '';
      if (this.$i18n.locale === 'en') {
        n = this.agent ? this.agent.eng_name_long : '';
      }
      return n;
    },
    title() {
      let t = this.agent ? this.agent.chi_title : '';
      if (this.$i18n.locale === 'en') {
        t = this.agent ? this.agent.eng_title : '';
      }
      return t;
    },
    address() {
      let t = this.agent ? `${this.agent.dept_chi_name} ${this.agent.dept_full_chi_addr}` : '';
      if (this.$i18n.locale === 'en') {
        t = this.agent ? `${this.agent.dept_eng_name} ${this.agent.dept_full_eng_addr}` : '';
      }
      return t;
    },
    sellInfo() {
      let s = { type: 'sell' };
      s.value = this.agent ? this.agent.sale : '';
      s.keyword = `{"suggestionWord":"${this.name}","type":"emp","value":"${this.agent.emp_id}","ics":"${this.ics}"}`;
      s.districts = this.selectedDistricts ? this.selectedDistricts.join(',') : null;
      return s;
    },
    leaseInfo() {
      let l = { type: 'lease' };
      l.value = this.agent ? this.agent.lease : '';
      l.keyword = `{"suggestionWord":"${this.name}","type":"emp","value":"${this.agent.emp_id}","ics":"${this.ics}"}`;
      l.districts = this.selectedDistricts ? this.selectedDistricts.join(',') : null;
      return l;
    },
    phoneUrl() {
      let t = 'tel://+852';
      if (this.agent && this.agent.phone) {
        t = `${t}${this.agent.phone.replace(' ', '')}`;
      }
      return t;
    },
    whatsappUrl() {
      let w = 'https://wa.me/';
      if (this.agent && this.agent.phone) {
        w = `${w}852${this.agent.phone.replace(' ', '')}`;
      }
      return w;
    },
    wechatUrl() {
      let u = '';
      if (this.agent && this.agent.emp_id) {
        u = `/ics/property/qr/wechat_page/?id=${this.agent.wechat_id}&name=${this.agent.eng_firstname}&link=${this.agent.wechat_qr}`;
        u = `${u}&lang=${this.$i18n.locale}`;
      }
      return u;
    },
    deptText() {
      switch (this.ics) {
        case 'i':
          return this.$t('main.MIDLAND_I');
        case 'c':
          return this.$t('main.MIDLAND_C');
        case 's':
          return this.$t('main.MIDLAND_S');
      }
    },
  },
  methods: {
    showWechatPopup() {
      this.$emit('showPopup', this.wechatUrl);
    },
    sendReport(method) {
      userBehaviour.sendReport(this.ics, '', method, 'agent', this.agent);
    },
    openStockPage(type) {
      let u = `${window.SITE_URL}find/${type === 'sale' ? 'sale' : 'lease'}?`;
      if (this.agent && this.ics) {
        u = u.concat(
          `?keywords={"suggestionWord"%3A"${this.agent.chi_name_long} ${this.agent.nickname} ","type"%3A"emp","value"%3A"${this.agent.emp_id}","ics"%3A"${this.ics}"}`,
        );
        if (this.selectedDistricts.length > 0) {
          u = `${u}&districts=${this.selectedDistricts}`;
        }
      }
      window.open(u);
    },
    openAgentPage() {
      let u = `https://qr.459.hk/`;
      if (this.agent) {
        let x = `${this.agent.email}`;
        u = u.concat(`${x.replace('@midlandici.com.hk', '')}`);
      }
      window.open(u);
    },
  },
};
</script>

<style scoped>
.agent-card-wrap {
  display: flex;
  flex-direction: column;
}
.agent-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #dddddd;
  padding: 7px 7px 15px;
  justify-content: space-between;
  height: -moz-available;
  height: -webkit-fill-available;
  height: fill-available;
  position: relative;
}

.ics-tag-container {
  position: absolute;
  top: 5px;
  right: 5px;
}
.agent-name {
  font-size: 18px;
  line-height: 23px;
}

.agent-contact {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
}
.agent-contact > div {
  font-size: 16px;
  background: #46bf6e;
  padding: 4px 8px;
  border-radius: 4px;
}
.agent-contact .whatsapp {
  cursor: pointer;
  height: 100%;
}
.agent-contact .wechat {
  cursor: pointer;
  display: grid;
  justify-items: center;
  grid-template-columns: auto 1fr;
  height: 100%;
  align-items: center;
}
.agent-contact a,
.agent-contact {
  color: #fff;
  text-decoration: none;
  align-items: center;
  justify-content: center;
}
.agent-contact .phone,
.agent-contact .phone a {
  color: #ffffff;
}

.agent-contact .phone a {
  display: grid;
  grid-template-columns: auto 1fr;
  text-align: center;
}

.agent-contact .whatsapp a {
  display: grid;
  justify-items: center;
  grid-template-columns: 24px 1fr;
  height: 100%;
}

.agent-contact .icon {
  max-width: 20px;
  max-height: 20px;
}
.agent-card >>> .emp {
  border: none;
  width: 88px;
}

.agent-photo-stock {
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;
  align-items: flex-end;
}

.fa-phone {
  width: 24px;
  line-height: 24px;
  text-align: center;
}

.agent-title,
.agent-address {
  line-height: 18px;
}

.agent-title {
  margin: 4px 0 8px;
}

.agent-address {
  margin-bottom: 6px;
}
.manager-tag,
.mitaclub-tag {
  background: #feeee8;
  padding: 2px 8px;
  color: #f6571a;
  line-height: 18px;
  width: fit-content;
}

.agent-name-tag {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.agent-sale-title,
.agent-lease-title {
  padding-right: 18px;
  background-image: url('data:image/svg+xml;utf-8,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.03281 13.5L6.22656 12.6938L9.93906 8.98127L6.22656 5.26877L7.03281 4.46252L11.5516 8.98127L7.03281 13.5Z" fill="%23252525"/></svg>');
  background-position: right;
  background-repeat: no-repeat;
  line-height: 18px;
  margin-bottom: 4px;
  cursor: pointer;
}

.agent-sale-unit {
  color: #f6571a;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  cursor: pointer;
}

.agent-lease-unit {
  color: #009342;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  cursor: pointer;
}

.agent-stock {
  display: flex;
  gap: 16px;
  padding: 10px 0px;
  margin-top: 20px;
}

.agent-photo-stock .emp-photo {
  width: auto;
}

.agent-photo-stock >>> .emp-photo {
  cursor: pointer;
}

.agent-dept {
  background: #f7f7f9;
  color: #9a9a9a;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  text-align: right;
  padding: 4px 16px;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

.phone-icon,
.wechat-icon {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
  background-position: center;
  background-repeat: no-repeat;
}

.phone-icon {
  background-image: url('~@/assets/icons/icon_Phone.svg');
}
.wechat-icon {
  background-image: url('~@/assets/icons/icon_Wechat.svg');
}

/* not mobile */
@media (min-width: 992px){
  .phone a{
    white-space: nowrap;
  }
}

/* CSS specific to iOS devices */
@supports (-webkit-touch-callout: none) {
  .agent-card {
    height: 40vh !important;
  }
}
</style>
